export async function exportPdf({ id, name }, { onToast } = {}) {
  const loading = onToast ? onToast('Exporting…', { type: 'loading' }) : null;
  const replace = (message, opts) => {
    if (loading && loading.update) loading.update(message, opts);
    else onToast && onToast(message, opts);
  };

  try {
    const r = await fetch(`/documents/${id}/export_pdf`);

    if (r.redirected) {
      replace('Your session expired — please log in and try again.', { type: 'error' });
      return false;
    }

    if (!r.ok) {
      const contentType = r.headers.get('Content-Type') || '';
      const body = contentType.startsWith('text/') ? await r.text() : '';
      console.error('PDF export failed:', { status: r.status, body, url: r.url });

      if (r.status === 502 || r.status === 504) {
        replace(body || 'PDF service is unreachable. Please try again in a moment.', { type: 'error' });
      } else {
        replace(`Export failed (${r.status}). Please try again.`, { type: 'error' });
      }
      return false;
    }

    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${name || 'document'}.pdf`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 0);
    replace('PDF exported', { type: 'success' });
    return true;
  } catch (err) {
    console.error('PDF export network error:', err);
    replace('Connection failed — please check your network and try again.', { type: 'error' });
    return false;
  }
}
